import "core-js/modules/es.array.push.js";
import { reactive, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'index',
  setup() {
    const {
      locale
    } = useI18n();
    const {
      push
    } = useRouter();
    const data = reactive({
      visible: false,
      showPopover: false,
      showPcPopover: false,
      actions: [{
        name: '繁體中文',
        code: 'tw'
      }, {
        name: 'English',
        code: 'en'
      }],
      userToken: localStorage.getItem('tk'),
      serverLink: localStorage.getItem('serverLink')
    }); // 数据
    const methods = {
      onSelect(action) {
        locale.value = action.code;
        localStorage.setItem('lang', action.code);
      },
      logOut() {
        localStorage.clear();
        push('/login');
      },
      toServer() {
        window.open(data.serverLink);
      }
    }; // 事件
    return {
      ...toRefs(data),
      ...methods
    };
  }
};